import { Component, OnInit, OnDestroy } from '@angular/core';
//import 'rxjs/add/observable/of';
//import { Subscription } from 'rxjs/Subscription';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
//import { Page } from '../../../models/list/page.model';
import { ManageMemoModel } from '../../../models/centre/manage-memo.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { SharedService } from '../../../shared/services/share.services';
import { ManageMemoMyTMBService } from './manage-memo-mytmb.service';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-manage-memo-mytmb',
    templateUrl: './manage-memo-mytmb.component.html',
    providers: [ManageMemoMyTMBService]

})
export class ManageMemoMyTMBComponent extends TMBDataTableComponent implements OnInit, OnDestroy {
   /*  private subscription: Subscription;
    public appConstants = AppConstants;
    page = new Page();

    dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total // Footer total message
    };
    customClasses = AppConstants.table.footerClasses; */

    dataRow = new Array<ManageMemoModel>();

    public memo: string;

    constructor(
        public manageMemoMyTMBService: ManageMemoMyTMBService,
        public sharedService: SharedService,
        public dialogService: DialogService,
        public utility: Utility) {
            super(sharedService);
    }

    ngOnInit() {
        this.manageMemoMyTMBService.getMyTMBMemo().subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.memo = data.value;
                }
            }
        );
    }

    onSave() {
        this.manageMemoMyTMBService.updateMemo({memo: this.memo}).subscribe(
            result => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                  // this.reloadPage(this.page.pageNumber, this.dataRow, true);
                }
            }
        );
    }

    // onEditItem(id) {
    //     this.dialogService.openComponentDialog(ModifyNewPopUpComponent,
    //         { id: id },
    //         { width: '750px' }).subscribe(
    //         result => {
    //             if (result) {
    //               this.reloadPage(this.page.pageNumber, this.dataRow);
    //             }
    //         }
    //         );
    // }

    // onAddNewMemo(): void {
    //     this.dialogService.openComponentDialog(ModifyNewPopUpComponent,
    //         {},
    //         { width: '750px' }).subscribe(
    //         (result) => {
    //             if (result) {
    //               this.reloadPage(this.page.pageNumber, this.dataRow);
    //             }

    //         }
    //         );
    // }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/manage-memo-mytmb/manage-memo-mytmb.component.ts